import type { ResultCode } from "@adyen/adyen-web/dist/types/components/types";
import type { PaymentAction } from "@adyen/adyen-web/dist/types/types";
import axios from "axios";

import type { PaymentDetailsResponse } from "~/types/Finance";
import type { Guid } from "~/types/Misc";
import type { PaymentDetailsData, PaymentRequest } from "~/types/Payment";

type PaymentResponseDto = {
  action: PaymentAction;
  refusalReason: string;
  refusalReasonCode: string;
  resultCode: ResultCode; // actually an enum
};

export const updatePaymentPrice = async ({
  orderId,
  paymentRequest,
  paymentMethod,
  adyenPaymentId,
  returnUrl,
  shippingAddressId,
  billingAddressId,
}: {
  orderId: Guid;
  paymentRequest: PaymentRequest;
  adyenPaymentId: string;
  paymentMethod: string;
  returnUrl: string;
  shippingAddressId: string;
  billingAddressId: string;
}): Promise<PaymentResponseDto> => {
  const response = await axios.patch(
    `${useRuntimeConfig().public.financeServiceUrl}/orders/${orderId}/payments`,
    {
      paymentRequest,
      adyenPaymentId,
      paymentMethod,
      returnUrl,
      shippingAddressId,
      billingAddressId,
    },
  );

  return response.data;
};

export const getPaymentDetails = async (
  data: PaymentDetailsData,
): Promise<PaymentDetailsResponse | undefined> => {
  const toast = useToast();
  try {
    const response = await axios.post(
      `${useRuntimeConfig().public.financeServiceUrl}/payments/details`,
      data,
    );

    return response.data;
  } catch (error) {
    toast.error(getErrorMessage(error)[0]);
  }
};
